import type { RouteObject as AdminRouteObject } from "react-router-dom";
import type { AdminDashboardDependencies } from "../composition/create-admin-dashboard-dependencies";
import { UserOperationsScreen } from "../../features/users/user-operations-screen";

export function createUsersRoute(dependencies: AdminDashboardDependencies): AdminRouteObject {
  return {
    path: "users",
    element: <UserOperationsScreen dependencies={dependencies} />,
  };
}
